@if (orderTemplates()?.length > 0) {
<div class="filter-list">
  @if (orderTemplates()?.length > 1) {
  <div>
    <p class="filter-item">
      {{ 'dias.filter.order_template.count.text' | translate : { '0': orderTemplates()?.length } }}
    </p>
  </div>
  } @else {
  <p class="filter-item">{{ 'dias.filter.order_template.one.text' | translate : { '0': orderTemplates()?.length } }}</p>
  } @for (orderTemplate of orderTemplates(); track orderTemplate) {
  <div class="filter-item custom-orderlist-link">
    <a [routerLink]="'/account/order-templates/' + orderTemplate.id" data-testing-id="order-template-list-title">
      {{ orderTemplate.title }}
    </a>
    <div>
      @if (orderTemplate.items?.length) {
      <a class="btn-tool d-inline-flex align-top">
        <ish-product-add-to-basket
          ishProductContext
          [parts]="getParts(orderTemplate)"
          displayType="icon"
          cssClass="text-primary p-0"
        />
      </a>
      } @if (orderTemplate.editable) {
      <a
        class="btn-tool"
        title="{{ 'account.order_template.list.link.remove' | translate }}"
        (click)="openDeleteConfirmationDialog(orderTemplate, deleteDialog)"
        data-testing-id="delete-order-template"
      >
        <fa-icon [icon]="['fas', 'trash-alt']" />
      </a>
      }
    </div>
  </div>
  }
</div>
} @else {
<p class="filter-item" data-testing-id="emptyList">
  {{ 'account.order_template.list.no_templates.text' | translate }}
</p>
}

<ish-modal-dialog
  #deleteDialog
  [options]="{
    confirmText: 'account.order_template.delete.button.text' | translate,
    rejectText: 'account.cancel.button.label' | translate,
    titleText: 'undefined'
  }"
  (confirmed)="delete($event)"
>
  {{ 'account.order_template.delete.do_you_really.text' | translate }}
</ish-modal-dialog>
